import React from 'react';

export default function WizardHeader({ currentStep, setStep }) {
  const steps = [
    { id: 1, title: 'Selecție Afecțiuni' },
    { id: 2, title: 'Parametri & Documente' },
    { id: 3, title: 'Rezultat & Dosar' },
  ];

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '28px', borderBottom: '2px solid #eee', paddingBottom: '12px' }}>
      {steps.map(step => {
        const isActive = step.id === currentStep;
        const isDone = step.id < currentStep;
        const isPending = step.id > currentStep;

        return (
          <div
            key={step.id}
            className={`wizard-step ${isActive ? 'wizard-step-active' : ''} ${isDone ? 'wizard-step-done' : ''} ${isPending ? 'wizard-step-pending' : ''}`}
            onClick={() => { if (isDone) setStep(step.id); }}
          >
            <span
              className="wizard-step-number"
              style={{
                backgroundColor: isActive ? '#0056b3' : isDone ? '#28a745' : '#ced4da'
              }}
            >
              {isDone ? '✓' : step.id}
            </span>
            {step.title}
          </div>
        );
      })}
    </div>
  );
}
